// extracted by mini-css-extract-plugin
export default {"container":"confirmationModal_container__T7OYU","buttons":"confirmationModal_buttons__ViQjx"};